/**
 * This is a thin wrapper over toast-base, a notification component.
 * It features cosmetic styling to indicate error state, and it does not
 * support autoTimeout.
 */
import ToastBase, {type SharedToastProps} from "./toast-base.tsx";

export const ErrorToast = (props: SharedToastProps) => {
    return <ToastBase isError={true} {...props} />;
};
